<template>

    <img v-if="loading" src="https://via.placeholder.com/1200x200?text=LOADING" alt="" >

    <!-- Single Images / Other -->
    <div>

        <p>View your images below. Please understand that all all images show are for preview purposes only and will be fully edited by our professional design team AFTER YOUR PURCHASE HAS BEEN PLACED.</p>
        <p>Purchased images will be made into 10" x 8" prints</p>

        <div id="product-items" class="uk-grid-small" uk-grid>
            <div
                v-for="image in images"
                :key="image.key"
                class="sp-product-grid-item uk-width-1-1 uk-width-1-3@s uk-width-1-4@l"

            >
                <div
                    v-for="product in filteredProducts('single')"
                    :key="product.key"
                    class="sp-outline-small sp-border-light-grey uk-link-reset uk-card uk-card-small uk-border-rounded uk-height-1-1 uk-flex uk-flex-column uk-background-white uk-box-shadow-hover-small"
                >
                    <div class="uk-card-media-top uk-cover-container uk-border-rounded-top uk-transition-toggle uk-light" tabindex="0" uk-lightbox>
                        <img :alt="product.package" uk-cover :data-src="image.url" :src="image.url">
                        <a :href="image.url" uk-cover>
                            <div class="uk-transition-fade uk-overlay-primary uk-position-cover">
                                <div class="uk-position-center">
                                    <span uk-icon="icon: expand; ratio: 2"></span>
                                </div>
                            </div>
                        </a>
                        <canvas height="480" width="600"></canvas>
                    </div>
                    <div class="uk-card-body uk-card-small uk-text-center">
                        <h3 class="uk-h5 uk-text-bold">{{ product.package }}</h3>
                    </div>
                    <div class="uk-card-footer uk-card-small uk-text-center uk-padding-remove uk-width-1-1">
                        <div v-if="alreadyInCart(product, image)" class="uk-button-group  uk-width-1-1">
                            <button disabled class="uk-button uk-button-secondary uk-width-expand border-bottom-left-5" type="button">In Cart</button>
                            <button @click="addProductToCart ({product, image})" class="uk-button uk-button-secondary border-bottom-right-5" type="button"><span uk-icon="plus"></span></button>
                        </div>
                        <button
                            v-else
                            class="uk-button uk-button-primary uk-width-1-1 border-bottom-5"
                            type="button"
                            @click="addProductToCart ({product, image})"
                        >Buy - {{ currency(product.price) }}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import { currency } from "@/filters/currency"
import { mapState, mapGetters, mapActions } from "vuex"

export default {
    data() {
        return {
            loading: false,
            image_options: {
                selected_image: 'IMG1',
                include_mounts: 'MNT0',
            }
        }
    },

    computed: {
        ...mapState({
            products: state => state.products,
            cartProducts: state => state.cart_products,
        }),
        ...mapGetters ({
            images: 'images',
            customer:  'customer',
        }),

    },

    methods: {
        currency,
        ...mapActions ({
            fetchProducts: 'fetchProducts',
            addProductToCart: 'addProductToCart'
        }),

        alreadyInCart (product, image) {
            return this.cartProducts.map(function(e) { return e.image_key; }).includes(image.image_key)
        },

        filteredProducts(value) {
            return this.products.filter(product => product.type == value )
        },
    },

    created() {
        this.loading = true
        this.fetchProducts()
            .then(() => this.loading = false)
    },

};
</script>

<style>
.uk-border-rounded-top {
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
}

.sp-product-grid-item {
    min-width: 223px;
}

.sp-product-table-image {
    width: 60px;
}

.sp-product-table-td {
    padding: 0;
}

.sp-product-table-container {
    /* padding: 10px 12px 0 0; */
}

/* padding */

.padding-bottom-75 {
    padding-bottom: 75px !important;
}

.padding-bottom-55 {
    padding-bottom: 55px !important;
}

/* border */
.border-bottom-5 {
    border-bottom-right-radius: 5px;
    border-bottom-left-radius: 5px;
}
.border-bottom-left-5 {
    border-bottom-left-radius: 5px;
}
.border-bottom-right-5 {
    border-bottom-right-radius: 5px;
}

.sp-border-light-grey {
    border: 1px solid #F0F0F0;
}
</style>
